import GardenStats2021 from "../../../../src/components/content/gardenStats2021";
import rtl from "../../../../content/svg/roam-the-lineup.svg";
import year from "../../../../content/thumbnails/2021_into_2022.png";
import * as React from 'react';
export default {
  GardenStats2021,
  rtl,
  year,
  React
};